import { render, staticRenderFns } from "./EggRecord.Total.vue?vue&type=template&id=4c5e4c0b&"
import script from "./EggRecord.Total.vue?vue&type=script&lang=js&"
export * from "./EggRecord.Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports